{
  "title": "Psychic Scream",
  "source": "Xanathar's Guide to Everything",
  "levelAndSchool": "9th-level enchantment",
  "level": 9,
  "castingTime": "1 action",
  "range": "90 feet",
  "components": "S",
  "duration": "Instantaneous",
  "description": [
    "You unleash the power of your mind to blast the intellect of up to ten creatures of your choice that you can see within range. Creatures that have an Intelligence score of 2 or lower are unaffected.",
    "Each target must make an Intelligence saving throw. On a failed save, a target takes 14d6 psychic damage and is stunned. On a successful save, a target takes half as much damage and isn’t stunned. If a target is killed by this damage, its head explodes, assuming it has one.",
    "A stunned target can make an Intelligence saving throw at the end of each of its turns. On a successful save, the stunning effect ends."
  ],
  "spellLists": ["bard", "sorcerer", "warlock", "wizard"]
}
